export enum StatusCodes {
    NoContent = 204,
    ServerError = 500
}